import { PERMISSIONS } from "@constants/user.roles";
import {
	EVENT_ENTITY_PVTC,
	EVENT_ENTITY_TEVTA,
	resolveEventEntity,
} from "@features/EventManagement/utils/eventEntity";
import { permissionListIncludes } from "@utils/permissionIdentifiers";

export type PsdaAdminDashboardAccessContext = {
	organizationTypeId?: number | null;
	roles?: unknown[];
	userTypeName?: string | null;
};

function isPvtcOrTevtaEntity(context: PsdaAdminDashboardAccessContext): boolean {
	const entity = resolveEventEntity({
		organizationTypeId: context.organizationTypeId,
		roles: context.roles,
		userTypeName: context.userTypeName,
	});
	return entity === EVENT_ENTITY_PVTC || entity === EVENT_ENTITY_TEVTA;
}

/**
 * PSDA Admin dashboard (`psda.admin.dashboard`) is only for PSDA org users.
 * PVTC/TEVTA admins must not see it even if the permission is mis-assigned in RBAC.
 */
export function canAccessPsdaAdminDashboard(
	hasPermission: (permission: string) => boolean,
	context: PsdaAdminDashboardAccessContext,
): boolean {
	if (!hasPermission(PERMISSIONS.PSDA_ADMIN_DASHBOARD)) {
		return false;
	}
	return !isPvtcOrTevtaEntity(context);
}

export function permissionListIncludesPsdaAdminDashboard(
	userPermissions: string[],
	context: PsdaAdminDashboardAccessContext,
): boolean {
	if (!permissionListIncludes(userPermissions, PERMISSIONS.PSDA_ADMIN_DASHBOARD)) {
		return false;
	}
	return !isPvtcOrTevtaEntity(context);
}
